import React from 'react';
import { PropTypes } from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as actions from '../../actions/leadActions';
import HomePageTable from './HomePageTable';
import { preprocessTableEntries } from "../../lib/homepageUtils";
import HOME_PAGE_BOTTOM from '../../constants/homePageBottom';

export class LatestLeads extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.sendRequest();
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedPartner &&
        this.props.selectedPartner !== prevProps.selectedPartner)
    {
      this.sendRequest(this.props.selectedPartner);
    }
  }

  sendRequest(partner = this.props.selectedPartner, page = 1) {
    this.props.actions.fetchLeads(
      {
        page: page,
        per_page: 15,
        ...partner
      },
      this.props.user
    );
  }

  render() {
    const leads = preprocessTableEntries(this.props.leads, 'created_at');

    return (
      <HomePageTable
        dataType="lead"
        content={leads}
        contentError={this.props.leadsError}
        title="Recent Submissions"
        noDataMessage="You have no recent leads submitted."
        moreInfoMessage={HOME_PAGE_BOTTOM.pipelineWaitTenMinMoreInfoMessage}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    leads: state.leads,
    leadsError: state.leadsError,
    selectedPartner: state.partner.selected,
    user: state.user
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch)
  };
}

LatestLeads.propTypes = {
  leads: PropTypes.array.isRequired,
  leadsError: PropTypes.bool.isRequired,
  selectedPartner: PropTypes.object,
  actions: PropTypes.object.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(LatestLeads);
